import { render, staticRenderFns } from "./OrganizationModuleList.vue?vue&type=template&id=2d8a2a3a&"
import script from "./OrganizationModuleList.vue?vue&type=script&lang=js&"
export * from "./OrganizationModuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports